const settings = {
    colors: {
        header: "white",
        headerItems: "black",
    },
}

export default settings